export const aggregateMaterialsRows = (rows, selectedMonths) => {
    return rows.map(item => {
        if (item.detalles && item.detalles.length > 0) {
            const details = item.detalles.filter(detalle => selectedMonths.includes(detalle.mes));
            const forecast = details.reduce((total, detalle) => total + (detalle.forecast || 0), 0);

            const uniqueCustomers = new Set(details.map(detalle => detalle.cliente));
            const customers = uniqueCustomers.size > 1 ? `Varios (${uniqueCustomers.size})` : (uniqueCustomers.size === 1 ? Array.from(uniqueCustomers)[0] : '');

            const uniqueParts = new Set(details.map(detalle => detalle.noParte));
            const parts = uniqueParts.size > 1 ? `Varios (${uniqueParts.size})` : (uniqueParts.size === 1 ? Array.from(uniqueParts)[0] : '');

            return {...item, _customers: customers, _forecast: forecast, _parts: parts, _details: details};
        }
        return {...item, _customers: item.cliente, _forecast: 0, _parts: item.partes, _details: []};
    });
}